package com.cybersoftsolution.cybersoftsolutionweb.models

import kotlinx.serialization.Serializable


    @Serializable
    actual enum class Category(val color: String) {
        News(color = Theme.Yellow.hex),
        Technology(color = Theme.Blue.hex),
        Programming(color = Theme.Green.hex),
        Desing(color = Theme.Red.hex),
        Suppport(color = Theme.Orange.hex),
        NoCategory(color = Theme.Transparent.hex),
    }